import makeStyles from '@mui/styles/makeStyles';
import { colors } from '@procore/core-react';

export const useStyles = makeStyles(() => ({
  title: {
    marginBottom: '15px',
  },
  instructions: {
    marginTop: 0,
    fontSize: '16px',
    fontWeight: 400,
    whiteSpace: 'pre-wrap',
  },
  showMoreOrLessText: {
    color: colors.black,
    display: 'inline-block',
    fontSize: '14px !important',
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
